const PENDO_WEB_SDK_ENVIRONMENT = 'io';
const DEFAULT_PENDO_GLOBAL_KEY = 'pendo';
export function createPendoWebSdkClientInitializer(options) {
    return async (identityOptions) => {
        const { initialize } = await import('@pendo/web-sdk');
        return await initialize({
            ...identityOptions,
            apiKey: options.apiKey,
            env: PENDO_WEB_SDK_ENVIRONMENT,
            globalKey: options.globalKey ?? DEFAULT_PENDO_GLOBAL_KEY
        });
    };
}
export function createPendoWebSdkOptionsFromEnvironment(environment) {
    const apiKey = environment.PUBLIC_PENDO_API_KEY;
    if (!apiKey) {
        return undefined;
    }
    return {
        apiKey
    };
}
